<div class="privacy">
    <div class="corpopagina">
        <div class="viewPar BLOBAlignLeft">
            <p><strong class="userFormat1">Condizioni generali</strong></p>
        </div>
    </div>
</div>
